import { useTranslation } from 'react-i18next';

import { StyledButton } from '@portalCommon/components/StyledButton';

import { useBoolean } from '@fuxi/eevee-hooks';
import { PointBurLEnumPortal, sendEventAndRedirectToConsultWitchParams } from '@portalCommon/utils';
import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const AboutYaotai = () => {
  const { t } = useTranslation();
  const [isExpand, { toggle }] = useBoolean(false);

  return (
    <div className={cx('background-wrapper', 'yaotai-wrapper')}>
      <div className={cx('content-wrapper', 'yaotai-content')}>
        <h1 className={cx('title-h1')}>{t('knowUs.yaotai.title')}</h1>
        <span className={cx('detail-span', { 'detail-span-expand': !isExpand })}>
          {t('knowUs.yaotai.detail1')}
          <br />
          <br />
          {t('knowUs.yaotai.detail2')}
          <br />
          <br />
          {t('knowUs.yaotai.detail3')}
          <br />
          <br />
          {t('knowUs.yaotai.detail4')}
        </span>
        <div className={cx('btn')} onClick={toggle}>
          <span className={cx('btn-text')}>{isExpand ? t('knowUs.yaotai.close') : t('knowUs.yaotai.open')}</span>
          <img
            className={cx('btn-img')}
            src={
              isExpand
                ? 'https://static.fuxi.netease.com/yaotai/portal/20220622/l4pd04uh_close.png'
                : 'https://static.fuxi.netease.com/yaotai/portal/20220622/l4pd04ui_open.png'
            }
            alt=""
          />
        </div>
        <div className={cx('desc-wrapper')}>
          <h2 className={cx('desc-h2')}>{t('knowUs.yaotai.desc1')}</h2>
          <h2 className={cx('desc-h2', 'highlight-desc-h2')}>{t('knowUs.yaotai.desc2')}</h2>
        </div>
        <StyledButton
          style={{ width: 189, height: 46, fontSize: 20, fontWeight: 600, letterSpacing: 4 }}
          styleType="gradient"
          onClick={() => {
            sendEventAndRedirectToConsultWitchParams(PointBurLEnumPortal.ContactUsConsult);
          }}>
          {t('knowUs.yaotai.button')}
        </StyledButton>
      </div>
    </div>
  );
};

export default AboutYaotai;
